// DO NOT EDIT THIS IS AN AUTOGENERATED FILE;
import * as React from 'react'

interface IconProps {
  color?: string
  size?: string | number
}

const SvgFutonBed = ({color = 'currentColor', size = 20}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill={color}
    height={size}
  >
    <path d="M13 6c.966 0 1.75.784 1.75 1.75v.75h.75l.256.013a2.5 2.5 0 0 1-.006 4.974v.263a.75.75 0 0 1-1.5 0v-.25h-8.5v.25a.75.75 0 0 1-1.5 0v-.263a2.5 2.5 0 0 1-.006-4.974L4.5 8.5h.75v-.75C5.25 6.784 6.034 6 7 6h6Zm-8.5 4a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2h-11ZM7 7.5a.25.25 0 0 0-.25.25v.75h6.5v-.75A.25.25 0 0 0 13 7.5H7Z" />
  </svg>
)

export default SvgFutonBed
